import axios from "axios";
import store from "@/store/store.js";
import eventBus from "@/util/EventBus.js";
import router from "@/router";

// definido en fichero .env
let api_url = "/produccion";

export default {
  getNextPaso: async function(origen, respuestasSel) {
    console.log(
      "INICIO getNextPaso.  origen:" + origen + ", respuesta: " + respuestasSel
    );
    console.log(
      store.step.datosIdentificacion == null
        ? null
        : store.step.datosIdentificacion
    );
    console.log("api_url " + api_url);

    eventBus.$emit("spinner-on");

    let response = await axios.post(api_url + "/online/nextPaso", {
      nombrePaso: origen,
      respuestas:
        respuestasSel.constructor === Array ? respuestasSel : [respuestasSel],
      idPresupuesto: store.step.idPresupuesto,
      numPresupuesto: store.step.numPresupuesto,
      idVersion: store.step.idVersion,
      tipoDoc:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.tipoDoc,
      numDoc:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.numDoc,
      nombre:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.nombre,
      ape1:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.ape1,
      ape2:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.ape2,
      telefono:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.telefono,
      mail:
        store.step.datosIdentificacion == null
          ? null
          : store.step.datosIdentificacion.email,
      idModelo: store.step.idModelo
    });

    eventBus.$emit("spinner-off");
    if (response.data.codigo == 0) {
      store.step.idPresupuesto = response.data.data.idPresupuesto;
      store.step.numPresupuesto = response.data.data.numPresupuesto;
    } else {
      eventBus.$emit("errorServidor", response.data.mensaje);
    }

    console.log("FIN getNextPaso. response:" + JSON.stringify(response.data));
    return response.data;
  },

  getInfoPaso: async function(origen) {
    console.log("INICIO getInfoPaso. origen " + origen);
    console.log("api_url " + api_url);

    eventBus.$emit("spinner-on");

    let response = await axios.post(api_url + "/online/descrPaso", {
      nombrePaso: origen,
      idPresupuesto: store.step.idPresupuesto,
      numPresupuesto: store.step.numPresupuesto,
      idMarca: store.step.idMarca,
      idModelo: store.step.idModelo,
      idVersion: store.step.idVersion
    });
    eventBus.$emit("spinner-off");

    if (response.data.codigo == 0) {
      store.step.tipoPantalla = response.data.data.tipoPantalla;
      store.step.pregunta = response.data.data.pregunta;
      store.step.subPregunta = response.data.data.subPregunta;
      store.step.textoAyudaTitulo = response.data.data.textoAyudaTitulo;
      store.step.textoAyuda = response.data.data.textoAyuda;
      store.step.infoAdicionalTitulo = response.data.data.infoAdicionalTitulo;
      store.step.infoAdicional = response.data.data.infoAdicional;
      store.step.posiblesRespuestas = response.data.data.posiblesRespuestas;
      store.step.productos = response.data.data.productosOfertados;
      store.step.mensaje = response.data.data.mensaje;
      store.step.resumen = response.data.data.resumenPresupuesto;
      store.step.grupoNavegacion = response.data.data.grupoNavegacion;
      store.step.fechaDefault = response.data.data.fechaDefault;
      store.step.tipoAutomovil = response.data.data.tipoAutomovil;
    } else if (response.data.codigo == 1008 || response.data.codigo == 9999) {
      let mensajeError = response.data.mensaje;
      console.log("Redirigimos a pantalla de error");
      router.push({
        name: "ShowErrorPresupuesto",
        params: {
          errorMessage: mensajeError
        }
      });
    }
    console.log("FIN getInfoPaso. response " + JSON.stringify(response.data));
    return response.data;
  },

  getFetchState: async function(idPresupuesto) {
    console.log("getFetchState: " + idPresupuesto);
    let response = await axios.post(api_url + "/online/fetchState", {
      idPresupuesto: idPresupuesto
    });
    if (response.data.codigo == 0) {
      store.step.idMarca = response.data.data.idMarca;
      store.step.idModelo = response.data.data.idModelo;
      store.step.idVersion = response.data.data.idVersion;
      store.step.numPresupuesto = response.data.data.numPresupuesto;
    }
    return response.data;
  },

  getSeleccionAnterior(pantalla) {
    for (var i = 0; i < store.select.length; i++) {
      console.log("Pantalla: " + store.select[i][0] + " " + store.select[i][1]);
      if (store.select[i][0] == pantalla) {
        console.log(
          "Valor Anterior en Paso " + pantalla + ": " + store.select[i][1]
        );
        return store.select[i][1];
      }
    }
    return null;
  },

  setSeleccion(pantalla, seleccion) {
    let enc = false;
    for (var i = 0; i < store.select.length; i++) {
      if (store.select[i][0] == pantalla) {
        store.select[i][1] = seleccion;
        enc = true;
      }
    }
    if (enc == false) {
      store.select.push([pantalla, seleccion]);
    }
  },

  customProducto: async function(data) {
    eventBus.$emit("spinner-on");
    let response = await axios.post(api_url + "/online/custom/producto", {
      idPresupuesto: store.step.idPresupuesto,
      productos: store.step.productos,
      option: {
        productoId: data.productoId,
        garantiaId: data.garantiaId,
        coberturaId: data.coberturaId,
        selectedId: data.selectedId
      }
    });
    if (response.data.codigo == 0) {
      store.step.productos = response.data.data;
      console.log(JSON.stringify(store.step.productos));
    }
    eventBus.$emit("spinner-off");
    return response;
  },

  selectProducto: async function(productoIdSelected) {
    eventBus.$emit("spinner-on");
    let response = await axios.post(api_url + "/online/select/producto", {
      idPresupuesto: store.step.idPresupuesto,
      productos: store.step.productos,
      productoId: productoIdSelected
    });
    return response;
  },

  crearGestionTeLlamamosError: async function(telefono) {
    console.log(
      "creaTeLlamamosError: " + store.step.idPresupuesto + " " + telefono
    );
    let response = await axios.post(api_url + "/online/crearTeLlamamosError", {
      idPresupuesto: store.step.idPresupuesto,
      telefono: telefono
    });
    return response.data;
  },
  getDocumentoInformativo: async function(idDocumento) {
    let url = api_url + "/online/documentoInformativo/" + idDocumento;
    await axios({
      method: "get",
      url: url,
      responseType: "blob"
    }).then(function(response) {
      let filename = "AsistenciaViaje.pdf";
      if (idDocumento == "AV_ORO") {
        filename = "AsistenciaViajeOro.pdf";
      } else if (idDocumento == "AV_PLATINO") {
        filename = "AsistenciaViajePlatino.pdf";
      } else if (idDocumento == "AV_MOTO") {
        filename = "AsistenciaViajeMoto.pdf";
      }
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }
};
